import React, { createContext, useReducer } from 'react';
import { ServiceReducer } from '../reducers/ServiceReducer';

export const ServiceContext = createContext();

const ServiceContextProvider = (props) => {
	const [services, dispatch] = useReducer(ServiceReducer, []);

	return(
		<ServiceContext.Provider value={ { services, dispatch } }>
			{props.children}		
		</ServiceContext.Provider>
	);
}

export default ServiceContextProvider;